// src/api/http.js
import axios from "axios";

const API = process.env.REACT_APP_API;

export const http = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Tag 402 responses so components can show Upgrade UI
http.interceptors.response.use(
  r => r,
  err => {
    const res = err?.response;
    if (res?.status === 402 && res?.data) {
      const e = new Error(res.data?.reason || "upgrade_required");
      e.isUpgrade = true;
      e.upgrade = res.data; // { error, reason, needed, upgrade_url }
      throw e;
    }
    throw err;
  }
);
